<template>
    <div>
        <v-container>
            <v-row no-gutters>
                <v-col cols="10">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link class="link-a" to="/Permission/Manage"
                            >Permission </router-link
                        >/
                        <router-link
                            class="link-a"
                            :to="'/Permission/Manage/' + teamId"
                            >Role </router-link
                        >/
                        <router-link
                            class="link-a"
                            :to="'/Permission/Manage/' + teamId + '/' + roleId"
                            >Main Menu </router-link
                        >/
                        <router-link
                            class="link-a"
                            :to="
                                '/Permission/Manage/' +
                                    teamId +
                                    '/' +
                                    roleId +
                                    '/' +
                                    menuId
                            "
                            >Sub Menu </router-link
                        >/ Member
                    </h1>
                </v-col>
                <v-col cols="2" class="text-right">
                    <v-btn rounded small color="success" @click="save()"
                        ><v-icon small>mdi-content-save</v-icon>Save</v-btn
                    >
                </v-col>
            </v-row>
            <v-card class="mt-5">
                <v-row>
                    <v-col cols="12">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th class="text-center">Username</th>
                                        <th class="text-center">Email</th>
                                        <th class="text-center">
                                            <v-btn
                                                x-small
                                                color="primary"
                                                @click="checkAll('1')"
                                                >View All</v-btn
                                            >
                                            <v-btn
                                                x-small
                                                color="secondary"
                                                @click="checkAll('3')"
                                                class="ml-2"
                                                >Disabled All</v-btn
                                            >
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(row, index) in form"
                                        :key="index"
                                    >
                                        <td class="text-center">
                                            {{ index + 1 }}.
                                        </td>
                                        <td>
                                            {{ row.name }}
                                        </td>
                                        <td>{{ row.email }}</td>
                                        <td class="text-center">
                                            <v-select
                                                :items="data_status"
                                                item-text="permission_type_name"
                                                item-value="permission_type_id"
                                                v-model="row.permission_type_id"
                                                menu-props="auto"
                                                label="Status"
                                                hide-details
                                            ></v-select>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/permission/users/`
const url_status = `${process.env.VUE_APP_ROOT_API}/api/permissiontype/`
const url_save = `${process.env.VUE_APP_ROOT_API}/api/permission/`

export default {
    mounted() {
        this.get_data()
    },
    computed: {
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            this.teamId = this.$route.params.team_id
            this.roleId = this.$route.params.role_id
            this.menuId = this.$route.params.menu_id
            this.submenuId = this.$route.params.submenu_id
            let { data } = await axios.get(
                url + this.roleId + "/" + this.submenuId
            )
            this.form = data

            let data_st = await axios.get(url_status)
            this.data_status = data_st.data
        },
        async save() {
            let data_form = this.form
            let { data } = await axios.post(
                url_save + this.submenuId,
                data_form
            )
            this.mutatesnackbar()
            this.$root.$router.push({
                path:
                    "/Permission/Manage/" +
                    this.teamId +
                    "/" +
                    this.roleId +
                    "/" +
                    this.menuId,
            })
        },
        checkAll(type_id) {
            let xx = this.form
            xx.map((item) => {
                item.permission_type_id = type_id
            })
        },
    },
    data() {
        return {
            data_status: [],
            teamId: 0,
            roleId: 0,
            menuId: 0,
            submenuId: 0,
            form: [],
        }
    },
}
</script>
<style scoped>
.fix-a {
    padding: 0px !important;
    margin-bottom: -10px !important;
}
</style>
